import API from "../authentication/AuthInterceptor";
import { useDistributorStore } from "../store/distributorStore";
import { User, NewUser } from "models/User";

export class UserService {
  async getUsers() {
    const distributorId = useDistributorStore.getState().distributorId;

    const response = await API.get(
      `/distributor/User/distributor/${distributorId}`
    );
    return response.data;
  }

  async getUserById(userId: number) {
    const reponse = await API.get(`/distributor/User/${userId}`);
    return reponse.data;
  }

  async getuserByToken(token: string) {
    const response = await API.get(`/distributor/User/token/${token}`);
    return { status: response.status, data: response.data };
  }

  async createUser(payload: NewUser) {
    const distributorId = useDistributorStore.getState().distributorId;

    if (!distributorId) {
      throw new Error(
        "Distributor ID not found."
      );
    }

    payload.fkDistributorId = distributorId;
    const response = await API.post(`/distributor/User`, payload);
    return response.data;
  }

  async updateUser(payload: User) {
    const distributorId = useDistributorStore.getState().distributorId;

    if (!distributorId) {
      throw new Error(
        "Distributor ID not found."
      );
    }

    payload.fkDistributorId = distributorId;
    const response = await API.put(`/distributor/User`, payload);
    return response.data;
  }

  async deleteUser(userId: number) {
    const response = await API.delete(`/distributor/User/${userId}`);
    return response.data;
  }

  async getUserByToken(token: string) {
    const response = await API.get(`/distributor/User/token/${token}`);
    return { status: response.status, data: response.data };
  }

  // Password management
  async sendForgotPasswordEmail(email: string){
    const response = await API.get(`/distributor/user/forgotPassword/${email}`);
    return response.data;
  }

  async sendResetPasswordEmail(userId: number) {
    await API.post(`/distributor/user/resetPassword/${userId}`);
  }

  async updatePassword(payload: { token: string; password: string }) {
    const response = await API.post(`/distributor/user/updatePassword`, payload);
    return response.data;
  }
}
